import { unstable_deprecatedPropType as deprecatedPropType } from '@material-ui/utils';
export default deprecatedPropType;